export default __webpack_public_path__ + "static/media/delete-logo.99cd8849.svg";